// extracted by mini-css-extract-plugin
export default {"remove":"removableTag_remove__fn+4+F9W","removeIcon":"removableTag_removeIcon__PiUlImSk"};